import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const formStyles = css`
	display: flex;
	flex-direction: column;
	gap: 28px;
	margin-bottom: 24px;
	background: var(--background-primary);
	${strictBreakpoints.onlyMobile} {
		gap: 16px;
		margin-bottom: 12px;
	}

	button {
		padding: 12px 24px;
		margin-top: 4px;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.05px;
		color: var(--text-primary-invert);
		background: #464c5c;
		border-radius: 8px;
		${strictBreakpoints.onlyMobile} {
			margin-top: 8px;
		}
	}
`;
